import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '../auth/profile/profile.service';

@Component({
  template: ''
})
export class NotFoundRedirectComponent implements OnInit {
  constructor(private router: Router, private profileService: ProfileService) {}

  ngOnInit() {
    if (this.profileService.isOnboarding()) {
      this.router.navigateByUrl('/setup/setupwizard/step1');
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
